#import "../fragments/contact-last-contacted-time-fragment.graphql"

query GetContactLastContactedTime($id: ID!) {
    contact(id: $id) {
        ...ContactLastContactedTimeFragment
    }
}
